import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProjet } from '../../api/PROJETS/projets';

export const useCreateProjet = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (projetData) => createProjet(projetData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projets'] });
    },
  });
};
